import { LicenseInfo } from "@mui/x-license";

LicenseInfo.setLicenseKey(
  "66c2e351639ccb5e608b1c9d47185da0Tz03NjY4MSxFPTE3Mjg5MjE2MzgwMDAsUz1wcm8sTE09cGVycGV0dWFsLEtWPTI="
);
